module.exports = __webpack_public_path__ + "static/img/middle-wmy.e76560c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/middle-wmy.png
// module id = KOQE
// module chunks = 9